import WorkCubeLogDBService from "../../db-services/workCubeLogDBService";
import { ILogResponseModel } from "../types";


class WorkCubeLogService {
    private dbService;

    constructor() {
        this.dbService = new WorkCubeLogDBService();
    }

    async getAllLogs(dayAgo: number): Promise<ILogResponseModel[]> {
        try {
            const response = await this.dbService.getAll(dayAgo)
            return response
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

}


export default WorkCubeLogService;
